/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 5/28/15.
 */

'use strict';

angular.module('prism-ui.package').service('PackageUtilService', function (
    _,
    DebugService,
    DynamicPropertiesService,
    PackageResourceFactory,
    RequestService
) {
    var self = this;
    self.validateAssetSelection = null;
    self.tabNewFunction = null;
    self.tabDeleteFunction = null;
    self.tabDeleteInvalid = null;
    self.tabAddDisabledFunction = null;
    self.tabAddDisabledInvalid = null;
    self.tabSaveFunction = null;
    self.tabRevertFunction = null;
    self.editorForm = null;
    self.postPackageSaveFunction = null;
    self.postCloseUpdate = null;
    self.setPristinePostSave = true;
    self.tabAdHocPartnerFunction = null;
    self.showClipScheduler = null;
    self.subTabRevertFunctions = {};
    self.subTabSaveFunctions = {};
    self.tabLoadDataFunction = null;
    self.tabUploadFunction = null;

    // Key value pair of field name and type
    var _errorsAndWarnings = {};
    var _contentCategories = {};

    self.parseNameFromPath = function (path) {
        return (path) ? path.split('/').pop() : '';
    };

    self.statusAllowsEdit = function (status) {
        //
        // TODO
        //
        // This should look at the package states that allow
        // modification, not the ones that don't.
        //
        // If the package status is empty, null, '42', etc. then
        // we probably don't want the package to be modified, yet
        // this method will allow it.
        //

        return (
            status !== 'CREATING_CLIP' &&
            status !== 'DELIVERING' &&
            status !== 'PENDING_APPROVAL' &&
            status !== 'PENDING_DELIVERY' &&
            status !== 'PENDING_RESTORE' &&
            status !== 'RESTORING' &&
            status !== 'TRANSCODING');
    };

    self.statusAllowsAutoDeliveryCheckbox = function (status) {
        return status === 'DRAFT' || status === 'REJECTED' || status === 'READY_FOR_DELIVERY';
    };

    self.statusAllowsReset = function (status) {
        return status !== 'DRAFT' && status !== 'READY_FOR_DELIVERY' && status !== 'STALLED';
    };

    self.statusAllowsDelivery = function (status) {
        return status === 'READY_FOR_DELIVERY' || status === 'DELIVERED' || status === 'STALLED';
    };

    self.packageHasNoErrors = function (pkg) {
        return parseInt(pkg.metadataErrorCount) === 0 && parseInt(pkg.mediaErrorCount) === 0;
    };

    self.packageCanBeDelivered = function (pkg) {
        return self.statusAllowsDelivery(pkg.status) && self.packageHasNoErrors(pkg);
    };

    self.errorsAndWarnings = function (newErrorsAndWarnings) {
        if (arguments.length) {
            _errorsAndWarnings = newErrorsAndWarnings;
            return _errorsAndWarnings;
        }
        return _errorsAndWarnings;
    };

    self.contentCategories = function (contentCategories) {
        if (arguments.length) {
            _contentCategories = contentCategories;
            return _contentCategories;
        }
        return _contentCategories;
    };

    var populateMap = function (result) {
        var errorsAndWarnings = {};
        var errors = result.errors;
        var warnings = result.warnings;
        angular.forEach(errors, function (error) {
            errorsAndWarnings[error.member] = {type: 'error', message: error.description};
        });
        angular.forEach(warnings, function (warning) {
            errorsAndWarnings[warning.member] = {type: 'warning', message: warning.description};
        });

        return errorsAndWarnings;
    };

    self.createErrorsAndWarningsMap = function (validationResult) {
        var errorsAndWarnings = {};
        angular.forEach(validationResult, function (result) {
            var key = result.source;
            errorsAndWarnings[key] = populateMap(result);
        });

        self.errorsAndWarnings(errorsAndWarnings);
    };

    let packageUpdateIntervalId = null;
    let packageUpdatePromise = null;

    self.cancelPollingInterval = function () {
        DebugService.debug(`PackageUtilService: status refresh cancelled`);
        RequestService.cancelRequestInterval(packageUpdateIntervalId);
        packageUpdateIntervalId = null;
    };

    const pollingIntervalCallback = () => {
        if (DebugService.trace()) {
            if (!this.lastStatusUpdate) {
                this.lastStatusUpdate = new Date();
            } else {
                let now = new Date();
                let duration = now - this.lastStatusUpdate;
                DebugService.trace(`PackageUtilService: last update occurred ${duration}ms ago`);
                this.lastStatusUpdate = now;
            }
        }

        if (!packageUpdatePromise) {
            packageUpdatePromise = self.pollForPackageUpdates().then(() => {
                packageUpdatePromise = null;
                DebugService.debug(`PackageUtilService: status updated`);
            });
        } else {
            DebugService.warn(`PackageUtilService: status update already in progress`);
        }
    };

    self.setPollingInterval = function () {
        DynamicPropertiesService.queryForProperties().then(() => {
            let intervalValue = DynamicPropertiesService.getPropValueAsInt('package.statusRefreshInterval', 30000);
            if (packageUpdateIntervalId === null) {
                packageUpdatePromise = null;
                packageUpdateIntervalId = RequestService.createRequestInterval(pollingIntervalCallback, intervalValue);
                DebugService.debug(`PackageUtilService: created status refresh interval (increment: ${intervalValue}ms)`);
            } else {
                DebugService.warn(`PackageUtilService: refusing to create another status update refresh interval`);
            }
        });
    };
});
